<template>
  <a id="navegador">

    <a class="btnFunc dibujar sellos">
      <i @click="sellos()" class="icon-stamp color-11"></i>
      <div v-show="openSeal" id="ContBtnSeal" class="barTool_subBtnContent" style="display: block;">
        <ul  class="barTool_subBtn posCenterContSeal">
          <li>
            <div class="barTool_btn_link">
              <img class="sello" id="check" src="../../assets/img/check-green.png" height="30"/>
            </div>
          </li>
          <li style="margin-left:20px">
            <div class="barTool_btn_link">
              <img class="sello" id="wrong" src="../../assets/img/equis-red.png" height="30"/>
            </div>
          </li>
        </ul>
      </div>
    </a>
    <a id="Resaltador" class="btnFunc dibujar">
      <!-- <img src="../../assets/img/herramientas/resaltador.png" alt="" width="30"> -->
     <i @click="resaltador()" class="icon-pencil color-11"></i>
     <div v-if="openPalette" class="btnPicker">
        <Chrome v-model="color"/>
        <div class="thicknessContainer">
          <div class="thicknessText">
            {{literal['GROSOR']}}:
          </div>
          <div class="thicknessSlider">
            <input
              type="range"
              min="1"
              max="32"
              step="0.01"
              class="slider"
              v-model="thicknessPalette"
            />
          </div>
        </div>
      </div>
    </a>  

    <a id="Borrar" class="btnFunc dibujar" style="top:-9px">
      <!-- <img src="../../assets/img/herramientas/eraser.png" alt="" width="30"> -->
      <!-- <i @click="borrar()" class="color-11 fas fa-eraser"></i> -->
      <div @click="borrar()">
        <v-icon style="color:white" class="color-11">mdi-eraser</v-icon>
      </div>
      
      <div v-show="openEraser" id="ContBtnSeal" class="sliderFloat eraser" style="visibility: visible;">
        <!-- <i class="font-less color-11"></i> -->
        <input
          type="range"
          min="1"
          max="16"
          step="0.01"
          class="slider"
          v-model="thicknessEraser"
        />
        <!-- <i class="font-plus color-11"></i> -->
      </div>
    </a>
  </a>
</template>

<script>
import $ from "jquery";
import { Chrome } from 'vue-color'
import { mapState } from 'vuex'

export default {
  name: "Dibujar",

  data: () => ({
    openPalette: false,
    openSeal: false,
    openEraser: false,

    thicknessPalette: 10, 
    thicknessEraser: 10,

    global: 'source-over',
    color: {hex: "#ff0000", a:1}
  }),
   components: {
    'Chrome': Chrome
  },
  methods: {
    resaltador(){
      this.openSeal = false;
      this.openEraser = false;

      this.global = 'xor';
      let cursor = require("@/assets/img/draw/resaltador-black.png");
      this.openPalette = !this.openPalette;
      $('#viewer').css('cursor','url(' + cursor + '), auto');
    },
    sellos(){
      this.openPalette = false;
      this.openEraser = false;

      this.global = 'source-over';
      this.openSeal = !this.openSeal; 
      $('#viewer').css('cursor','auto');
    },
    borrar(){
      this.openPalette = false;
      this.openSeal = false;

      this.openEraser = !this.openEraser;
      let cursor = require("@/assets/img/draw/eraser-black.png");
      $('#viewer').css('cursor','url(' + cursor + '), auto');
      this.global = 'destination-out';
    }
  },
  updated: function(){
    console.log($('.vc-chrome-color-wrap .vc-chrome-active-color').css('width', this.thicknessPalette + 'px'))
    console.log($('.vc-chrome-color-wrap .vc-chrome-active-color').css('height', this.thicknessPalette + 'px'))

    console.log($('.vc-chrome-color-wrap .vc-checkerboard').css('width', this.thicknessPalette + 'px'))
    console.log($('.vc-chrome-color-wrap .vc-checkerboard').css('height', this.thicknessPalette + 'px'))
    
  },
  computed:{
    ...mapState(['literal'])
  },
  mounted: function() {
    
    $(document).ready(function() {
      $('.sello').click((e) => {
        borrarListener();
        $('#viewer').css('cursor','auto');
        sello = e.target.id;
        canvas.addEventListener("mousedown", insertarSello)
      });
      $("#Regresar").click(() => {
        $('#viewer').css('cursor','auto');
        borrarListener();
      });
      $("#DibujarTrazo, #Resaltador, #Borrar").click(() => {
        borrarListener();
        agregarListener();
      });
    });

    let sello = '';

    //Elimina todos los Listener existentes
    let borrarListener = () => {
      canvas.removeEventListener("mousedown", insertarSello)
      canvas.removeEventListener("mousedown", dibujarTrazodown);
      canvas.removeEventListener("mousemove", dibujarTrazomove);
      canvas.removeEventListener("mouseup", dibujarTrazoup);

      canvas.removeEventListener("touchstart", touchStart);
      canvas.removeEventListener("touchend", touchend);
      canvas.removeEventListener("touchmove", touchmove);
    };

    //Logica para inserta un sello
    let insertarSello = (e) => {

      //Se crea la imagen
      let img = new Image();
      img.src = $('#' + sello).attr('src');
      img.height = $('#' + sello).height() / 2.0;
      img.width = $('#' + sello).width() / 2.0;
      rect = canvas.getBoundingClientRect();
      let ratio = 1.0 / this.$store.state.escala;

      //Se halla su posicion
      x = e.clientX - rect.left - img.width / (2 * ratio);
      y = e.clientY - rect.top - img.height / (2 * ratio);
      ctx.globalCompositeOperation = 'source-over';
      ctx.globalAlpha = 1;

      //Se pinta el sello en el canvas
      ctx.drawImage(img, ratio * x, ratio * y, img.height, img.width);
    };

    /****   Dibujar en  CANVAS *****/
    let canvas = document.getElementById("canvasMain");

    let ctx = canvas.getContext("2d");
    let rect = canvas.getBoundingClientRect();

    //Se Agrega los listener correpondiente a los trazos que se hagan en el canvas
    let agregarListener = () => {
      
      canvas.addEventListener("mousedown", dibujarTrazodown);
      canvas.addEventListener("mousemove", dibujarTrazomove);
      canvas.addEventListener("mouseup", dibujarTrazoup);

      canvas.addEventListener("touchstart", touchStart);
      canvas.addEventListener("touchend", touchend);
      canvas.addEventListener("touchmove", touchmove);
    };

    let x = 0;
    let y = 0;
    let dibujando = false;

    //Logica del Dibujo tipo Paint
    let dibujar = (x1, y1, x2, y2) => {
      
      if ($("body").hasClass("kinetic")) {
        ctx.beginPath();
        ctx.lineCap = 'round';

        ctx.globalCompositeOperation = this.global;
        let ratio = 1.0 / this.$store.state.escala;
        ctx.strokeStyle = this.color.hex;
        
        //Entra si esta en modo BORRADOR
        if(this.global == 'destination-out'){
          ctx.lineWidth = this.thicknessEraser;
          ctx.arc(ratio * x1, ratio * (y1 + 15), this.thicknessEraser / 2, 0, 2*Math.PI);
          ctx.fill();
          ctx.globalAlpha = 1;
        } else {
          ctx.lineWidth = this.thicknessPalette;
          // ctx.globalCompositeOperation = 'destination-atop';
          
          if(0.9 < this.color.a){
            ctx.globalAlpha = 1; //Se extrae el alpha del picker Color
            ctx.globalCompositeOperation = 'source-over';
          } else {
            ctx.globalAlpha = this.color.a / 4; //Se extrae el alpha del picker Color
          }
          ctx.moveTo(ratio * x1, ratio * y1);
          ctx.lineTo(ratio * x2, ratio * y2);
        }
        ctx.stroke();
        // ctx.closePath();
      }
    };

    let dibujarTrazodown = e => {
      rect = canvas.getBoundingClientRect();
      x = e.clientX - rect.left;
      y = e.clientY - rect.top;
      dibujando = true;
    };

    let dibujarTrazomove = e => {
      rect = canvas.getBoundingClientRect();
      if (dibujando === true) {
        dibujar(x, y, e.clientX - rect.left, e.clientY - rect.top);
        x = e.clientX - rect.left;
        y = e.clientY - rect.top;
      }
    };

    let dibujarTrazoup = e => {
      if (dibujando === true) {
        dibujar(x, y, e.clientX - rect.left, e.clientY - rect.top);
        x = 0;
        y = 0;
        dibujando = false;
      }
    };
    

    let touchStart = e => {
      rect = canvas.getBoundingClientRect();
      x = e.touches[0].clientX - rect.left;
      y = e.touches[0].clientY - rect.top;
      dibujando = true;
    };
    let tempX;
    let tempY;
    let touchmove = e => {
      rect = canvas.getBoundingClientRect();
      if (dibujando === true) {
        dibujar(x, y, e.touches[0].clientX - rect.left, e.touches[0].clientY - rect.top);
        tempX = e.touches[0].clientX;
        tempY = e.touches[0].clientY;
        x = e.touches[0].clientX - rect.left;
        y = e.touches[0].clientY - rect.top;
      }
    };

    let touchend = e => {
      if (dibujando === true) {
      
        dibujar(x, y, tempX - rect.left, tempY - rect.top);
        x = 0;
        y = 0;
        dibujando = false;
      }
    };

    /****   Fin de Dibujar en  CANVAS *****/
  }
};
</script>

<style>
.barTool_subBtn {
  box-sizing: content-box;
  border: 2px solid #393737;
  border-bottom: none;
  margin: 0;
  padding: 0 5px;
  display: flex;
  position: absolute;
  background-color: #3c3c3b;
  left: 50%;
  top: 50px;
  height: 50px;
  border-radius: 0 0 20px 20px;
}

.barTool_subBtn.posCenterContHighlighther {
  margin-left: -100px;
}

.barTool_subBtn.posCenterContSeal{
  margin-left: -45px;
  top: 56px;
  height: 42px;
}

.vc-chrome-body {
  padding: 16px 0px 12px !important;
  height: 60px !important;
}

.vc-chrome-color-wrap{
  display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px !important;
}

.vc-checkerboard{
top: auto !important;
    right: auto !important;
    bottom: auto !important;
    left: auto !important;
}
</style>
